import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children, adminOnly, driverOnly }) => {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center text-muted-foreground"><Loader2 className="h-6 w-6 animate-spin" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (driverOnly) {
    if (user.role !== "driver") return <Navigate to="/" replace />;
    return children;
  }
  if (user.role === "driver") return <Navigate to="/portal" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};
